var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"cta"},[(_vm.data)?[_c('h5',[_vm._v(_vm._s(_vm.data.title))]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.data.text)}}),_c('RouterButton',{staticClass:"cta__btn btn-solid--black mt-m",attrs:{"to":_vm.data.button_url}},[_vm._v(_vm._s(_vm.data.button_text))])]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }